// Libraries
var React = require('react');
var $ = require('jquery');

// Styles
require('./Progress.scss');

// Components
var TimePoint = require('./TimePoint');
var Event = require('./Event');
var Dash = require('./Dash');

class Progress extends React.Component {
	constructor(props) {
		super(props);

		// NEW
		this.pointHalfWidth = 10;
		this.timePointsNew = {
			base: [
				{ display: '0', position: 0, offset: this.pointHalfWidth },
				{ display: '15', position: 0 },
				{ display: '30', position: 0 },
				{ display: 'HT', position: 0 },
				{ display: '60', position: 0 },
				{ display: '75', position: 0 },
			],
			normalPen: [
				{ display: '90', position: 0 },
				{ display: 'Pen', position: 0 },
			],
			extra: [
				{ display: '90', position: 0 },
				{ display: '105', position: 0 },
			],
			extraPen: [
				{ display: '90', position: 0 },
				{ display: '105', position: 0 },
				{ display: '120', position: 0 },
				{ display: 'Pen', position: 0 },
			],
			end: [
				{ display: 'FT', position: 0, offset: 0 - this.pointHalfWidth }
			]
		};

		this.state = {
			minute: 0,
			progressWidth: 0,
			showTimeScale: false,
			timePoints: [],
			groupedEvents: [],
			// NEW
			totalTime: 90,
			timeScaleNew: 0,
			timePointsNew: [
				...this.timePointsNew.base,
				...this.timePointsNew.end
			],
		}
	}

	componentDidMount() {
		window.addEventListener("resize", this.resizeTimescale.bind(this));

		$(document).ready(() => {
			this.resizeTimescale();
		});
	}

	// NEW
	getTimePoints = data => {
		switch(true) {
			// 120 min + Pen
			case (data.isShootOut && data.showExtraTime):
				return [...this.timePointsNew.base, ...this.timePointsNew.extraPen, ...this.timePointsNew.end];
			// 120 min no Pen
			case (!data.isShootOut && data.showExtraTime):
				return [...this.timePointsNew.base, ...this.timePointsNew.extra, ...this.timePointsNew.end];
			// 90 min + Pen
			case (data.isShootOut && !data.showExtraTime):
				return [...this.timePointsNew.base, ...this.timePointsNew.normalPen, ...this.timePointsNew.end];
			default:
				return [...this.timePointsNew.base, ...this.timePointsNew.end];
		}
	};

	componentWillReceiveProps(nextProps) {
		this.setTimescalePos(nextProps);

		if(this.props.events !== nextProps.events) {
			this.placeEvents(nextProps);
		}
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.resizeTimescale);
	}

	resizeTimescale(event) {
		this.setTimescalePos(this.props);
		this.placeEvents(this.props);
	}

	// NEW
	getTotalTime = timepoints => {
		const map = {
			'7': 90,
			'9': 120,
			'11': 150,
		};

		return map[String(timepoints.length)];
	};

	// NEW
	setTimescalePos = nextProps => {
		const timepoints = this.getTimePoints(nextProps);
		const totalWidth = this.timeline.offsetWidth;
		const scale = totalWidth / (timepoints.length - 1);
		const timeScale = totalWidth / this.getTotalTime(timepoints);

		this.setState({
			showTimeScale: true,
			totalTime: this.getTotalTime(timepoints),
			totalWidth,
			scaleNew: scale,
			timeScaleNew: timeScale,
			timePointsNew: timepoints.map((timepoint, i) => {
				const offset = (timepoint.display === 'Pen' ? 0 - timeScale * 10 : timepoint.offset) || 0;
				return Object.assign({}, timepoint, {
					position: scale * i - this.pointHalfWidth + offset,
				})
			})
		}, () => this.updateProgressBar(nextProps));
	};

	// NEW
	getProgressWidth = nextProps => {
		const lastEvent = nextProps.events[nextProps.events.length - 1];
		let width = 0;

		if (nextProps.isFullTime) {
			width = this.state.totalWidth;
		} else if (lastEvent && (lastEvent.Period === 'ShootOut' || lastEvent.Type === 'PenaltyShot')) {
			width = lastEvent.Minute * this.state.timeScaleNew;
		} else if (nextProps.Period === 'Prematch') {
			width = 0;
		} else {
			width = nextProps.minute * this.state.timeScaleNew;
		}

		return width > this.state.totalWidth ? this.state.totalWidth : width;
	};

	// NEW
	updateProgressBar = nextProps => {
		this.setState({
			progressWidth: this.getProgressWidth(nextProps),
			isFullTime: nextProps.isFullTime,
			minute: nextProps.minute,
		}, () => this.placeEvents(nextProps));
	}

	placeEvents(nextProps) {
		let homeEvents = nextProps.events.filter(x => x.IsHomeTeam);
		let awayEvents = nextProps.events.filter(x => !x.IsHomeTeam);

		var processedHomeEvents = [];
		var processedAwayEvents = [];

		// get the position of each icon on the timeline
		homeEvents.forEach(element => {
			processedHomeEvents.push(this.evaluatePosition(element, nextProps));
		});
		awayEvents.forEach(element => {
			processedAwayEvents.push(this.evaluatePosition(element, nextProps));
		});

		// group icons that overlap
		if(processedHomeEvents.length > 0) {
			processedHomeEvents = this.groupEvents(processedHomeEvents);
		}
		if(processedAwayEvents.length > 0) {
			processedAwayEvents = this.groupEvents(processedAwayEvents);
		}

		this.setState({ groupedEvents: processedHomeEvents.concat(processedAwayEvents) });
	}

	groupEvents(array) {
		let groupedArray = [];
		let iconWidth = 35;

		for (let i = 0; i < array.length; i++) {
			if (i === 0) {
				groupedArray.push({ position: array[i].position, id: array[i].id, group: [array[i]] });
				continue;
			}

			// this one overlaps with the previous one
			if (groupedArray[groupedArray.length - 1].position + iconWidth > array[i].position) {
				let group = groupedArray[groupedArray.length - 1];
				group.group.push(array[i]);
				group.position = ((array[i].position - group.group[0].position) / 2) + group.group[0].position;
				continue;
			} else {
				groupedArray.push({ position: array[i].position, id: array[i].id, group: [array[i]] });
				continue;
			}
		}

		return groupedArray;
	}

	evaluatePosition(element, nextProps) {
		let iconWidth = 35;
		let type = element.HighlightType === "Booking" ? element.CardType : element.HighlightType;
		let position = (element.Minute * this.state.timeScaleNew) - (iconWidth / 2);
		return { 
			type: type, 
			position: position >= this.state.totalWidth - iconWidth ? this.state.totalWidth - iconWidth : position, 
			id: element.Id,
			isHome: element.IsHomeTeam,
			outcome: element.Outcome,
			period: element.Period,
			isShootOut: nextProps.isShootOut,
		};
	}

	handleEventClick = (selectedEvent) => {
		this.props.selectedEventChanged(selectedEvent.id);
	}

	render() {
		return (
			<div className="Progress">
				<div className="Progress__wrapper">
					<div className="Progress__timescale">
						{this.state.showTimeScale && this.state.timePointsNew.map(function (point, index) {
							return (<TimePoint key={index} display={point.display} position={point.position} />)
						})}
					</div>
					<div className="Progress__timeline" id="js-timeline" ref={timeline => this.timeline = timeline}>
						<div className="Progress__bar" style={{ width: this.state.progressWidth }}>
							<div className="Progress__events">
								{this.state.groupedEvents.length > 0 && this.state.groupedEvents.map((event, index) => {
									return (<Dash key={index} position={event.position} />)
								})}
								{this.state.groupedEvents.length > 0 && this.state.groupedEvents.map((event, index) => {
									return (<Event key={index} selectEvent={this.props.selectEvent} selectedEvent={this.props.selectedEventId} onEventClick={this.handleEventClick} event={event} />)
								})}
							</div>
						</div>
					</div>
					<div className="Progress__separator">
						<div className="Progress__line" style={{ width: this.state.progressWidth }}></div>
					</div>
				</div>
			</div>
		)
	}
}

module.exports = Progress;



// WEBPACK FOOTER //
// ./src/components/MDC/Timeline/Progress.js